module.exports = __webpack_public_path__ + "img/ZXYH.1ba50f68.png";